import * as React from 'react';
import {connect} from 'react-redux';
import {setTitle} from '../../actions/topHeaderActions';
import {fetchAllBusinessObjects, fetchAllDataViews} from '../../actions/boCoreActions'
import {DataTypesEnum} from "../../components/bo-core/enums/dataTypesEnum";
import {EVENTS} from "../../config/boCore";
import DataViewConfigAgGrid from "../../components/bo-core/grids/DataViewConfigAgGrid/DataViewConfigAgGrid";
import * as toastr from "toastr";
import DataViewColumnsAgGrid from "../../components/bo-core/grids/DataViewColumnsAgGrid/DataViewColumnsAgGrid";
import Utils from "../../Utils";

interface Props {
    fetchAllBusinessObjects(): void
    fetchAllDataViews(): void
    setTitle(param: string): void
    dataViewsWrapper: any
    businessObjectsWrapper: any
}

interface State {
    currentDataView: any
    businessObjects: any
    selectedBOType: boolean
    toastrMsg: string
    currentSlide: string
}

declare const Slick: any;

class DataViewConfiguration extends React.Component<Props, State> {
    columnsAgGridRef = null;
    configAgGridRef = null;
    constructor(props) {
        super(props);
        this.state = {
            currentDataView: null,
            businessObjects: null,
            selectedBOType: false,
            toastrMsg: 'Please select BO Type',
            currentSlide: 'first',
        };
        this.columnsAgGridRef = React.createRef();
        this.configAgGridRef = React.createRef();
    }

    UNSAFE_componentWillMount() {
        $(document.body)
            .unbind(EVENTS.dataViewConfiguration.setCurrentDataView)
            .on(EVENTS.dataViewConfiguration.setCurrentDataView, (event: any) => {
                this.setState({currentDataView: event.args.dataView})
            });
        this.props.fetchAllBusinessObjects();
        this.props.fetchAllDataViews();
    }

    componentDidMount() {
        this.props.setTitle("Data View Configuration");
    };

    UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
        const {dataViewsWrapper, businessObjectsWrapper} = this.props;
        if (businessObjectsWrapper !== nextProps.businessObjectsWrapper && nextProps.businessObjectsWrapper && nextProps.dataViewsWrapper) {
            this.setState({
                currentDataView: nextProps.dataViewsWrapper.getDataViews(DataTypesEnum.ARRAY)[0],
                businessObjects: nextProps.businessObjectsWrapper.getBusinessObjects(DataTypesEnum.ARRAY)
            });
        }

        if (dataViewsWrapper !== nextProps.dataViewsWrapper && nextProps.dataViewsWrapper && nextProps.businessObjectsWrapper) {
            this.setState({
                currentDataView: nextProps.dataViewsWrapper.getDataViews(DataTypesEnum.ARRAY)[0],
                businessObjects: nextProps.businessObjectsWrapper.getBusinessObjects(DataTypesEnum.ARRAY)
            });
        }
    }

    componentWillUnmount() {
        this.props.setTitle("");
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.initAccordeon();
    }

    static enableButton(id, msg) {
        Utils.$("#" + id).prop("disabled", false).attr("title", msg);
    }

    static disableButton(id, msg) {
        Utils.$("#" + id).prop("disabled", true).attr("title", msg);
    }

    static eventDispatcher(action, args) {
        Utils.$(document.body).trigger({
            type: action,
            args: args
        })
    }

    initAccordeon() {
        Utils.$('#accordeon').liteAccordion({
            responsive: true,
            minContainerWidth: 800,
            containerWidthOffset: 270,
            containerHeightOffset: 70,
            theme: "dark",
            rounded: true,
            enumerateSlides: true,
            synchronousResize: true,
            onSlideAnimComplete: () => {
            },
            onBeforeTriggerSlide: (args) => {
                if (Slick.GlobalEditorLock.isActive) {
                    Slick.GlobalEditorLock.commitCurrentEdit();
                }

                if ($(args).prop("id") === "dataViewFormSlide") {
                    if (!this.state.currentDataView || !this.state.businessObjects) {
                        return false;
                    }
                    if (!this.state.selectedBOType) {
                        toastr.warning(this.state.toastrMsg);
                        return false;
                    }
                    if (this.configAgGridRef.current.hasChanges()) {
                        this.configAgGridRef.current.changesPrompt();
                        return false;
                    } else {
                        this.setState({currentSlide: 'second'});
                    }
                }

                if ($(args).prop("id") === "dataViewConfigurationSlide") {
                    if (this.columnsAgGridRef.current.hasChanges()) {
                        this.columnsAgGridRef.current.changesPrompt();
                        return false;
                    } else {
                        this.setState({currentSlide: 'first'});
                    }
                }

                DataViewConfiguration.eventDispatcher(EVENTS.dataViewConfiguration.openColumnsGrid, {
                    currentDataView: this.state.currentDataView
                });

                return true;
            },
            onTriggerSlide: () => {
                if (Slick.GlobalEditorLock.isActive()) {
                    Slick.GlobalEditorLock.cancelCurrentEdit();
                }
                $("#clone_form").hide();
            }
        });

        $("#hide-nav-btn").on("click", function () {
            const core = $("#accordeon").data("coreInstance");
            if (!$(document.body).hasClass("mini-navbar")) {
                core.setSlideWidth(window.innerWidth - 120);
                resizeToFitBrowserWindow(true);
            } else {
                core.setSlideWidth(window.innerWidth - 270);
                resizeToFitBrowserWindow(false);
            }
        });
    }

    setSelectedDataView = (dataView) => {
        const nodeData = dataView.data;
        const dView = this.props.dataViewsWrapper.getDataView(nodeData.id);
        const index = this.state.businessObjects.findIndex((item) => item.id === nodeData.boClass.id);
        if (index !== -1) {
            // const dView = new DataView(nodeData.id,nodeData.viewName, this.state.businessObjects[index] , nodeData.columns || [], nodeData.isActive, nodeData.isDefault);
            dView.setBusinessObjectClass(this.state.businessObjects[index]);
            this.setState({
                currentDataView: dView,
                selectedBOType: true
            })
        }
    };

    noSelectedItems = (message = 'Please select BO Type') => {
        this.setState({
            selectedBOType: false,
            toastrMsg: message
        })
    };

    render() {
        const {currentDataView, businessObjects} = this.state;

        return (
            <div style={{height: "100%",  backgroundColor: '#262C2E'}} className={"container-fluid"}>
                { !currentDataView || !businessObjects ? null : <div id="accordeon">
                    <ol>
                        <li>
                            <h2 id={"dataViewConfigurationSlide"} title={'SHIFT + LeftArrow'}>
                                <span style={{fontSize: 15}}>Data View Configuration</span></h2>
                            <div id={"dataViewConfigurationGrid"}>
                                <DataViewConfigAgGrid businessObjects     = {businessObjects}
                                                      setSelectedDataView = {this.setSelectedDataView}
                                                      noSelectedItems     = {this.noSelectedItems}
                                                      currentSlide        = {this.state.currentSlide}
                                                      configAgGridRef     = {this.configAgGridRef}
                                />
                            </div>
                        </li>
                        <li>
                            <h2 id={"dataViewFormSlide"} title={'SHIFT + RightArrow'}>
                                <span style={{fontSize: 15}}>Data View Configuration Form</span>
                            </h2>
                            <div id={"dataViewFormGrid"}>
                                <DataViewColumnsAgGrid
                                    columnsAgGridRef = {this.columnsAgGridRef}
                                    currentDataView  = {currentDataView}
                                    currentSlide     = {this.state.currentSlide}/>
                            </div>
                        </li>
                    </ol>
                </div>}
            </div>
        )
    }
}

const calculateNewDimensions = (minNavBarEnabled) => {
    const $accordeon = $("#accordeon");
    if (minNavBarEnabled) {
        return {
            height: $accordeon.height() - 35,
            width: $accordeon.width() - 100
        }
    }
    return {
        height: $accordeon.height() - 35,
        width: $accordeon.width() - 100
    }
};

const resizeToFitBrowserWindow = (minNavBarEnabled) => {
    const newSizes = calculateNewDimensions(minNavBarEnabled);
    const $dataViewConfigurationGrid = $('#DataViewConfigurationGrid');
    const $dataViewColumnsGrid = $('#DataViewColumnsGrid');

    $dataViewConfigurationGrid.height(newSizes.height).width(newSizes.width);

    $dataViewColumnsGrid.height(newSizes.height).width(newSizes.width);

    const DataViewColumnsGrid = $dataViewColumnsGrid.data("gridInstance");
    const DataViewConfigurationGrid = $dataViewConfigurationGrid.data("gridInstance");

    if (new RegExp('MSIE [6-8]').exec(navigator.userAgent) === null && DataViewColumnsGrid && DataViewConfigurationGrid) {
        DataViewColumnsGrid.resizeCanvas();
        DataViewConfigurationGrid.resizeCanvas();
    }
};

const mapStateToProps = (state) => {
    return {
        dataViewsWrapper: state.boCore.dataViewsWrapper,
        businessObjectsWrapper: state.boCore.businessObjectsWrapper
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchAllBusinessObjects: () => {
            dispatch(fetchAllBusinessObjects());
        },
        fetchAllDataViews: () => {
            dispatch(fetchAllDataViews());
        },
        setTitle: (title) => {
            dispatch(setTitle(title))
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(DataViewConfiguration)



// WEBPACK FOOTER //
// ./app/views/bo-core/DataViewConfiguration.tsx